if (!customElements.get('free-shipping-progress')) {
  class FreeShippingProgress extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    async refresh() {
      try {
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        const cart = await fetch(`${cartUrl}.js`).then((response) => response.json());
        this.render(cart);
      } catch (error) {
        // Leave the last rendered state in place if the cart can't be fetched.
      }
    }

    render(cart) {
      const threshold = parseInt(this.dataset.threshold, 10) || 5000;
      this.hidden = cart.item_count === 0 || !cart.requires_shipping;

      const remaining = threshold - cart.total_price;
      const percent = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      const money = (cents) =>
        new Intl.NumberFormat('en-US', { style: 'currency', currency: cart.currency || 'USD' }).format(cents / 100);

      const bundleQuantity = parseInt(this.dataset.bundleQuantity, 10) || 3;
      const shippableItems = cart.items
        .filter((item) => item.requires_shipping)
        .reduce((sum, item) => sum + item.quantity, 0);
      const itemsNeeded = bundleQuantity - shippableItems;

      const message = this.querySelector('.free-shipping-progress__message');
      if (remaining > 0) {
        message.innerHTML = `You're <strong>${money(remaining)}</strong> away from free shipping 🥒`;
      } else if (itemsNeeded > 0) {
        message.innerHTML = `🎉 <strong>Free shipping</strong> unlocked! Add ${itemsNeeded} more ${itemsNeeded === 1 ? 'item' : 'items'} to save 15%.`;
      } else {
        message.innerHTML = '🎉 <strong>Free shipping + 15% off</strong> unlocked!';
      }
      this.querySelector('.free-shipping-progress__fill').style.width = `${percent}%`;
    }
  }

  customElements.define('free-shipping-progress', FreeShippingProgress);
}
